// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-8IO","placeholder":"styles_placeholder__PkZy3"};